import { Component, Story, Knobs } from './DocTypes';

const NumberFormattingKnobs: Knobs = {
  text: { default: '54038.1000000000', editor: 'number' },
  formattingOptions: {
    attribute: 'formatting-options',
    default: '{"style": "currency","currency":"GBP"}',
    editor: 'multilinetextbox',
  },
};
const numberFormattingStory: Story = {
  title: 'Number formatting',
  description: 'You can format numbers using the `formatting-options` attribute',
  coreComponent_v3: {
    html: `<div style="font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'">
  <tag3-format data-type='decimal'{{...knobs}}></tag3-format>
</div>`,
    knobs: NumberFormattingKnobs,
  },
  reactWrapper_v3: {
    jsx: `<div style={{fontFamily: "Inter, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial,  sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'"}}>
  <Tag3Format dataType='decimal'{{...knobs}}></Tag3Format>
</div>`,
    knobs: NumberFormattingKnobs,
  },
};

const DateFormattingKnobs: Knobs = {
  text: { default: '25-12-2019 10:20:01', editor: 'textbox' },
  dataType: {
    default: 'date',
    editor: 'dropdown',
    editorOptions: ['date', 'datetime'],
  },
};
const dateFormattingStory: Story = {
  title: 'Date formatting',
  description: 'You can format numbers using the `formatting-options` attribute',
  coreComponent_v3: {
    html: `<div style="font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'">
  <tag3-format {{...knobs}}></tag3-format>
</div>`,
    knobs: DateFormattingKnobs,
  },
  reactWrapper_v3: {
    jsx: `<div style={{fontFamily: "Inter, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial,  sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'"}}>
  <Tag3Format {{...knobs}}></Tag3Format>
</div>`,
    knobs: DateFormattingKnobs,
  },
};

export const TagFormatDocs: Component = {
  type: 'component',
  name: 'format',
  description: 'Renders a formatted text element',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'text',
      description: 'The text',
      type: 'string',
    },
    {
      name: 'dataType',
      default: 'string',
      description: 'The type of the field that is used for value formatting',
      type:
        'string | integer | decimal | currency | date | datetime | boolean | image | email | phonenumber',
    },
    {
      name: 'formattingOptions',
      description:
        'Additional formatting options for numbers. This maps directly to the options parameter in Intl.NumberFormat see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [numberFormattingStory, dateFormattingStory],
};
